import { getConfig } from 'owa-service/lib/config';
import { isNetworkAvailable } from './isNetworkAvailable';

export function isOffline(): boolean {
    return !isNetworkAvailable() || !!getConfig().disableAllRequests;
}
